import App from '../components/app'
import DivBottom from '../components/divBottom'
import NavbarNotAuth from '../components/navbarNotAuth'
import NavbarTopAdmin from '../../admin/components/navbarTopAdmin'
import NavbarBottomAdmin from '../../admin/components/navbarBottomAdmin'

function Orvieto() {
    return (<>
        {localStorage.getItem('logged') && localStorage.getItem('email') !== 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />}
        <div style={{ marginTop: '6rem' }}></div>
        <App />
        <div style={{ marginBottom: '50px' }}>
            <div style={{
                textAlign: 'center',
                padding: '3rem 0rem 1rem 0rem'
            }}>
                <h1>Orvieto</h1>
                <h5 style={{ color: 'grey', position: 'relative' }}>UMBRIA
                    <span style={{
                        position: 'absolute',
                        left: '1rem',
                        backgroundColor: 'maroon',
                        color: 'whitesmoke',
                        padding: '3px',
                        borderRadius: '5px'
                    }}>ARTE
                    </span>
                </h5>
            </div>

            {/* {foto && */}
            <div className='mt-1'>
                <div className='galleria container-fluid'>
                    <div className='gbox1'>
                        <img src={require('../image/sterling-lanier-bpb76Qu3JAw-unsplash.jpg')}
                            height='100%' width='100%' alt='' />
                    </div>
                    <div className='gbox2'>
                        <h4>Bellezza e arte</h4><hr />
                        <p className='mt-3'>
                            <b>Orvieto</b>, in provincia di Terni, ha origini storiche e nell'antichità fu un'importante città Etrusca
                            in quanto sono presenti  indelebili testimonianze che dimostrano le sue radici.
                            Fu anche un solido e potente comune medievale e i suoi territori si estendevano fino al mar Tirreno.
                            E in questo periodo storico che va dal 1300 d.C. al 1400 furono edificati molti dei suoi monumenti principali
                            tra cui il <b>Duomo</b>, la <b>Torre del Moro</b>, il <b>Palazzo del Capitano del Popolo</b>, ed alcuni dei più bei palazzi nobili.
                        </p>
                        <hr /><br />
                        <p>
                            Il <b>Duomo Santa Maria Assunta</b> custodisce opere d'arte, sculture e dipinti di valore inestimabile.
                            In particolare la cappella di <b>San Brizio</b> contiene un capolavoro della pittura italiana del XV secolo
                            con il ciclo di affreschi di <b>Luca Signorelli</b> che propone allo spettatore il tema del <mark>Giudizio Universale</mark>
                            : un uso perfetto di colori, scene e disegni dei corpi talmente suggestivi a tal punto che Michelangelo ne trasse spunto
                            per realizzare la Cappella Sistina.
                        </p>

                    </div>
                    <img src={require('../image/francesco-dondi-uOaT4q5XRbI-unsplash.jpg')}
                        alt='' className='galleria_immagine addImg' />
                    <img src={require('../image/t-s-BrqGXDXs3y8-unsplash.jpg')}
                        alt='' className='galleria_immagine addImg' />
                </div>

                <p className='m-3'>
                    A Orvieto non può mancare la visita al <b>pozzo di San Patrizio</b>, dalla sezione circolare. Largo 13 metri e profondo 62,
                    è provvisto di due scale elicoidali ed hanno la particolarità di non far incontrare mai le persone che scendono con quelle che salgono.
                </p>

                <div className='container mt-2'>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>IL DUOMO</h1>
                        <img src={require('../image/mario-la-pergola-AeGitzwf3qw-unsplash.jpg')}
                            alt='' className='imgCittà' />
                        <br />
                        <p className='mt-3'>
                            Alta 53 metri, monumento nazionale Italiano, la basilica di <b>Santa Maria Assunta</b> è una stupenda
                            cattedrale in stile romano-gotico che si trova nel centro storico della città.
                            Emerge in maniera imponente tra tutte le altre strutture e in particolare la sua facciata coloratissima e dettagliata
                            attira i turisti da tutto il mondo lasciandoli incantati.<br />
                            Al suo interno, nella <b>Cappela del Corporale</b>, viene custodita la <b>reliquia</b> che rappresenta uno dei miracoli più sensazionali della
                            storia della Chiesa: l'abito di Pietro da Praga utilizzato durante una messa a Bolsena nel 1263 e macchiatosi di sangue sgorgato dall'Ostia al momento dell'eucarestia.
                            Il duomo venne costruito sul finire del 1200 per volere di papa Niccolò IV con l'idea di creare un monumento
                            capace di custodire il <b>sacro lino del miracolo del sangue di Bolsena</b> citato sopra.<br />
                            L'aspetto gotico è maggiormente visibile nella sua imponente e meravigliosa facciata,
                            realizzata in tre secoli (1290-1591) grazie alla collaborazione di più di venti artisti.
                            All'interno della basilica troviamo la <b>Cappella di San Brizio</b> decorata con il <b>Giudizio Universale</b>,
                            un ciclo di affreschi iniziati da <i> Beato Angelico</i> e <i>Benozzo Gozzoli</i> nel 1447, poi terminati da <i>Luca Signorelli nel 1504</i>
                            : un turbinio di immagini che lasciano senza fiato!
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>POZZO DI SAN PATRIZIO</h1>
                        <img src={require('../image/francesco-dondi-uOaT4q5XRbI-unsplash.jpg')}
                            alt='' className='imgCittà' />
                        <br />
                        <p className='mt-3'>
                            Su richiesta di <b>Papa Clemente VII</b> fu realizzata questa meravigliosa opera architettonica da
                            <b> Antonio da Sangallo il Giovane</b> nel XVI secolo.
                            L'idea era quella di creare una fonte di approvigionamento idrico durante i conflitti.
                            Il pozzo è scavato nel tufo ed ha una profondità di oltre 60 mt.
                            Presenta la particolarità di avere due scale elicoidali, una per scendere (248 scalini) e l'altra per salire (249 scalini).
                            ed è un'opera unica nel suo generei in quanto chi scende non incontra mai chi sale.
                            Nell'antichità venivano utilizzati animali da soma come asini e cavalli per scendere nel pozzo e
                            risalire con i carichi d'acqua. Evitare di far incontrare le bestie che scendevano con quelle che risalivano fu
                            un grande vantaggio in quanto si evitavano intoppi e rallentamenti.
                            Inizialmente il pozzo era detto <b>Pozzo della Rocca</b> e solo tre secoli dopo prese il nome
                            <b> Pozzo di San Patrizio</b>, per volere dei frati del convento dei Servi che si ispirarono alla leggenda del
                            santo irlandese, appunto San Patrizio.
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>ORVIETO SOTTERRANEA</h1>
                        <img src={require('../image/jeremy-bishop-4PwRZXbXKxY-unsplash.jpg')}
                            alt='' className='imgCittà' />
                        <br />
                        <p className='mt-3'>
                            Un gruppo di speleologi orvietani, dalla fine degli anni settanta in poi, ha guidato l'esplorazione del sottosuolo
                            della città ed ha riscoperto di più di <b>1200 cavità artificiali</b>.
                            Dopo aver appreso della pericolosa instabilità del terreno, la Regione Umbria avviò studi più approfonditi
                            su questa scoperta sotterranea di Orvieto captandone anche le proprietà storiche e archeologiche.
                            Le cantine compongono la maggioranza dei sotterranei ma negli anni 50, con l'arrivo dei frigoriferi e con
                            sistemi di produzione vinicola moderni, quasi tutte le cantine sono state abbandonate.
                            Ai sotterranei si accede facilmente e sono molto ampi, perfettamente percorribili anche da chi non è a suo agio
                            nei luoghi chiusi.
                        </p>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>GASTRONOMIA</h1>
                        <img src={require('../image/gabriel-tovar-TPDfnKAKbVc-unsplash.jpg')}
                            alt='' className='imgCittà' />
                        <br />
                        <ul className='mt-3'>
                            <li>
                                <b>Pasta alla norcina</b> per riscoprire un gustosissimo piatto
                                della cucina umbra, una pietanza irrestibile.
                            </li>
                            <li>
                                <b>Crescia al formaggio</b> viene solitamente preparata in occasione della Pasqua.
                                E' un lievitato salato arricchito da Parmigiano Reggiano DOP e Pecorino grattugiati.
                            </li>
                            <li>
                                <b>Umbrichelli al tartufo nero</b> sono un tipo di pasta fatta a mano.
                                Il condimento perfetto è aggiungere dell'aglio e dell'olio extravergine di oliva.
                            </li>
                            <li>
                                <b>Cinghiale in umido</b>, è un secondo piatto ricco e sostanzioso con sapori intensi.
                            </li>
                            <li>
                                <b>Coniglio in porchetta con finocchio selvatico</b>.
                            </li>
                            <li>
                                <b>Torta al testo</b>, un pane antichissimo. Conosciuta come "crescia" nella zona di Gubbio
                                e chiamata "torta del panaro" a Terni, è una specialità che potrebbe ricordare la piadina.
                            </li>
                        </ul>
                    </div>

                    <div className='divCittà mt-5'>
                        <h1 className='text-center'>COSA VEDERE</h1>
                        <img src={require('../image/t-s-BrqGXDXs3y8-unsplash.jpg')}
                            alt='' className='imgCittà' />
                        <br />
                        <ul style={{ listStyleType: 'upper-roman' }} className='mt-3'>
                            <li>
                                <b>Duomo di Orvieto</b> icona della città stessa, il Duomo è una delle più belle cattedrali
                                d'Italia e del mondo. L'inizio dei lavori per la costruzione avvenne nel 1290 e fu
                                fortemente voluta sia dalla Chiesa che dal Comune, in sostituzione delle due chiese che si erigevano
                                sulla bella piazza.
                            </li>
                            <li>
                                <b>Pozzo di San Patrizio</b>, nome ispirato dalla nota leggenda del santo irlandese
                                secondo la quale Patrizio fosse custode di una grotta senza fondo
                                dalla quale dopo aver visto le pene dell'Inferno, si poteva accedere al Purgatorio arrivando
                                persino ad intravedere il Paradiso.
                            </li>
                            <li>
                                <b>Orvieto sotterranea</b>, un groviglio di grotte, cunicoli, pozzi e cisterne creato dall'uomo
                                in quasi tre millenni di continuo lavoro manuale.
                                Ripercorrendo queste cavità, oltre 1200 grotte, si possono ancora ammirare emozionanti resti archeologici
                                di epoca etrusca e medievale.
                            </li>
                            <li>
                                <b>Decugnano dei Barbi</b> è una storica e rinomata cantina internazionale nelle colline dell'orvietano.
                                E' circondata da un quadro paesaggistico da favola:
                                da un lato le grotte tufacee fresche e umide di origine etrusca ospitano gli spumanti Metodo Classico,
                                dall'altro lato potrete ammirare i filari di vigna, su terreni storici di origine pliocenica.
                            </li>
                            <li>
                                <b>Cappella di San Brizio</b> realizzata all'interno del Duomo di Orvieto rappresenta una delle opere
                                più rappresentative della pittura rinascimentale italiana.
                                Affrescata dal Signorelli e dal Beato Angelico è un capolavoro assoluto, le scene sono avvolgenti e
                                lasciano senza parole!
                            </li>
                            <li>
                                <b>Torre del Moro</b>, costruita nel 1200, svetta nel centro storico della città e da sempre segna
                                l'ora agli abitanti di Orvieto.
                                E' alta 47 metri e i suoi 160 gradini portano ad una vista stupenda e suggestiva su tutta Orvieto e dintorni.
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
            {/* } */}

            <DivBottom />
        </div >
    </>
    )
}
export default Orvieto